import { Button, Flex, Popup, Spacing, Table, Text } from '@approvalmax/ui/src/components';
import { useCallback, useMemo } from 'react';

import { columns } from './ChangedBeneficiariesPopupContent.config';
import { messages } from './ChangedBeneficiariesPopupContent.messages';
import { ChangedBeneficiariesPopupContentProps } from './ChangedBeneficiariesPopupContent.types';

export const ChangedBeneficiariesPopupContent = (props: ChangedBeneficiariesPopupContentProps) => {
    const { subTitle, beneficiaryDiscrepancies, onApply, onClose } = props;

    const handleApply = useCallback(() => {
        onApply(
            beneficiaryDiscrepancies.map((descrepancy) => ({
                id: descrepancy.airwallexBeneficiaryId,
                version: descrepancy.beneficiaryVersion,
            }))
        );
    }, [beneficiaryDiscrepancies, onApply]);

    const tableData = useMemo(
        () => beneficiaryDiscrepancies.map((item) => ({ ...item, id: item.airwallexBeneficiaryId })),
        [beneficiaryDiscrepancies]
    );

    return (
        <>
            <Popup.Header
                title={messages.title}
                subTitle={subTitle}
                actions={
                    <Flex spacing='16'>
                        <Button color='red40' onClick={onClose}>
                            {messages.cancel}
                        </Button>

                        <Button color='blue80' onClick={handleApply}>
                            {messages.apply}
                        </Button>
                    </Flex>
                }
            />

            <Popup.Body spacing='32'>
                <Spacing height={4} />

                <Flex direction='column' spacing='24'>
                    <Flex direction='column' spacing='16'>
                        <Text font='body' fontSize='large'>
                            {messages.description1}
                        </Text>

                        <Table columns={columns} data={tableData} headerColor='white100' />
                    </Flex>

                    <Text font='body' fontSize='large'>
                        {messages.description2}
                    </Text>
                </Flex>
            </Popup.Body>
        </>
    );
};

ChangedBeneficiariesPopupContent.displayName = 'ChangedBeneficiariesPopupContent';
